// extracted by mini-css-extract-plugin
module.exports = {"menu":"kzqtA","large":"_2x_xQ","placementTop":"_2CTRq","placementBottom":"_3kktA"};